import React from 'react';
import { NavLink } from 'react-router-dom';

interface MenuItemProps {
  to: string;
  children: React.ReactNode;
}

export const MenuItem: React.FC<MenuItemProps> = ({ to, children }) => {
  return (
    <li>
      <NavLink
        to={to}
        className={({ isActive }) =>
          `block w-full text-left px-6 py-[16px] mb-2 ${
            isActive ? 'bg-yellow font-bold' : ''
          }`
        }
      >
        {children}
      </NavLink>
    </li>
  );
};
